import { defineStore } from 'pinia'
import state from '@/stores/nests/state'
import actionsStore from '@/stores/nests/actions'
import gettersStore from '@/stores/nests/getters'
import mutationsStore from '@/stores/nests/mutations'

export const useNestStore = defineStore('nest', () => {
  const getters = gettersStore(state)
  const mutations = mutationsStore(state)
  const actions = actionsStore(mutations)
  return {
    state,
    getters,
    mutations,
    actions,
  }
})
